export enum CampaignTargetType {
  SAVED_SEARCH = "SAVED_SEARCH",
  CONTACT_LIST = "CONTACT_LIST",
  TAG = "TAG",
  FILTER = "FILTER",
}
